// extracted by mini-css-extract-plugin
module.exports = {"hotspot":"hotspots_hotspot__3WnCy","hotspot_circle":"hotspots_hotspot_circle__1LAWR","pulsate":"hotspots_pulsate__33c9W"};